import {
  START_LOADING,
  END_LOADING,
  FETCH_BUILDINGS,
  FETCH_BUILDING,
  ADD_BUILDING,
  UPDATE_BUILDING,
  DELETE_BUILDING,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  buildings: [],
  building: null,
};

const buildings = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_BUILDINGS:
      return {
        ...state,
        buildings: action.payload.data,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_BUILDING:
      return { ...state, building: action.payload };
    case ADD_BUILDING:
      return {
        ...state,
        buildings: [...state.buildings, action.payload],
        building: action.payload, // Assuming you want to view the newly added building
      };
    case UPDATE_BUILDING:
      return {
        ...state,
        buildings: state.buildings.map((building) =>
          building._id === action.payload._id ? action.payload : building
        ),
        building:
          state.building && state.building._id === action.payload._id
            ? action.payload
            : state.building,
      };
    case DELETE_BUILDING:
      return {
        ...state,
        buildings: state.buildings.filter(
          (building) => building._id !== action.payload
        ),
        building:
          state.building && state.building._id === action.payload
            ? null
            : state.building,
      };
    default:
      return state;
  }
};

export default buildings;
